import styled from 'styled-components'

export const AuthorName = styled.strong`
  &:hover {
    color: var(--blue) !important;
  }
`

AuthorName.displayName = 'AuthorName'

export const AvatarWrapper = styled.div`
  margin-top: 0.625rem;
`

AvatarWrapper.displayName = 'Avatar'

export const Wrapper = styled.div`
  &:last-child {
    border-bottom: none !important;
  }
`

Wrapper.displayName = 'Wrapper'

export const CommentContent = styled.div`
  --avatar-size: 2.875rem;
  width: calc(100% - var(--avatar-size));
  margin-left: var(--avatar-size);
`

CommentContent.displayName = 'CommentContent'

export const CommentText = styled.p`
  overflow-wrap: anywhere;

  a {
    color: var(--blue) !important;

    &:hover {
      text-decoration: underline !important;
    }
  }
`

CommentText.displayName = 'CommentText'
